<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>
      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="110px" >         
          <el-row>
            <el-col :span="15">
              <el-form-item :label="$t('field.model')" required>  
                <el-select v-model="model" :placeholder="$t('msg.pleaseSelect')" multiple @change="changeModel()" style="width:100%">
                  <el-option v-for="item in modelOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col> 
            <el-col :span="9">
              <el-form-item :label="$t('field.timeRange')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"  @change="changeDate()"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"  @change="changeDate()"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row> 

        <el-row style="padding-bottom:10px"> 
          <el-col>   
            <el-button type="warning" icon="el-icon-download" @click="exportExcel" ></el-button>  
          </el-col>
        </el-row> 
 
        <el-row>       
          <el-table :data="tableData.data" id="dtlTable" style="width:600px" >          
            <el-table-column  v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i" :fixed="i==0">                 
              <template slot-scope="scope"> <span>{{ scope.row[v.field] }} </span> </template>
            </el-table-column>
          </el-table>
        </el-row>      
        <br>
        <el-row>       
          <el-table :data="tableSumData.data" id="sumTable" style="width:1000px" >          
            <el-table-column  v-for="(v, i) in tableSumData.columns" :prop="v.field" :label="v.title" width="200" :key="i" :fixed="i==0">                 
              <template slot-scope="scope"> <span>{{ scope.row[v.field] }} </span> </template>
            </el-table-column>
          </el-table>
        </el-row>  
      </el-form>
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTable'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindModelListByFeedbackSn, apiYieldStatByModel, apiGetShippingCnt } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

export default {
  name: 'yieldStatByModel',
  data() {    
    return {    
      model: '',
      sdate: '',
      edate: '',
      modelOpts:[],
      tableData: {
        columns:[],
        data:[]       
      },
      tableSumData: {
        columns:[
        { field: "shipping", title: 'Shipping'},
        { field: "return_inc", title: 'Return rate (%) - INCX'},
        { field: "return_customer", title: 'Return rate (%) -Customer'},
        { field: "return_tbd", title: 'Return rate – TBD (%)'},
        { field: "returnRate", title: 'Return rate (%)'}],
        data:[]       
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
					display: false
				},
        scales: {
					yAxes: [{
						ticks: {
                // max: 25000,
                min: 0,
                // stepSize: 1,
                beginAtZero: true,
                padding: 5, 
            },
						gridLines: {
							display: true
						}
					}],
					xAxes: [{
						ticks: {
							beginAtZero: true
						},
						gridLines: {
							display: false
						}
					}]
				},
      }

    };
  }, 
  components: {
    Breadcrumb,
    Table   
  },
  mounted() {
    this.edate = new Date();  
    this.sdate = new Date(this.edate.getFullYear()+'-01-01');
    apiFindModelListByFeedbackSn({ headers: authHeader()}).then((response) => { 
      
      this.modelOpts = [];     
      var tempArr = [];  
      if(response.data != null && response.data.length >0){       
        this.modelOpts = response.data;      
        this.model = this.modelOpts;  
        this.findData();
      }
    }).catch((err) => {
      console.log(err);
    });
    
 
  },
  methods: {
  
    findData(){      

      if(this.model.length > 0){
        let models = '',sdate = '', edate = '';
        this.model.forEach((item, index) => {   
          models += item+';';
        });
        if(this.sdate != null && this.sdate != ''){        
          sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
        }
        if(this.edate != null && this.edate != ''){        
          edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
        }
        apiYieldStatByModel({ headers: authHeader(), models:models, sdate : sdate, edate : edate}).then((response) => { 
          this.tableData.columns = [];
          this.tableData.columns.push({ field: 'type', title: 'Model', width:180});  
           let custNos = [];
          Object.entries(response.data[0]).forEach(([key, value]) => {
            if(key != 'type' && key != 'typeSum'){
              this.tableData.columns.push({ field: key, title: key, width:100 });    
            }
          });  

          this.tableData.columns.push({ field: 'typeSum', title: 'Summary'});  
          this.tableData.data = response.data;
          let lastData = this.tableData.data [this.tableData.data.length-1];


          let totalModelStr = '';
          this.tableData.data.forEach((item, index) => { 
            if(item.type != 'Summary'){
              totalModelStr +=item.type+';';
            }  
          });
          apiGetShippingCnt({ headers: authHeader(), condition:totalModelStr}).then((response) => {    
            if(response.status == 200 && response.data != null ){       
              let shippingCnt = parseInt(response.data);
              this.tableSumData.data= [{ "shipping":shippingCnt, "return_inc": ( parseInt(lastData.INCX) / shippingCnt * 100 ).toFixed(4),
              "return_customer":  ( parseInt(lastData.Customer) / shippingCnt * 100 ).toFixed(4) , "return_tbd": ( parseInt(lastData.TBD) / shippingCnt * 100 ).toFixed(4),
              "returnRate": ( parseInt(lastData.typeSum) / shippingCnt * 100 ).toFixed(4)}];

            }
          }).catch((err) => {  console.log(err); });

          
        }).catch((err) => {
          console.log(err);
        });
      }else{
        this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      }     
    },
    changeModel(){
      this.findData();
    },  
    changeDate(){
      this.findData();
    },
    exportExcel(){
      this.$nextTick(function () {
        // 判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去，
        var fix = document.querySelector('.el-table__fixed');
        var wb;
        if (fix) {
          wb = XLSX.utils.table_to_book(document.querySelector('#dtlTable').removeChild(fix));
          document.querySelector('#dtlTable').appendChild(fix);
        } else {
          wb = XLSX.utils.table_to_book(document.querySelector('#dtlTable'));
        }
        let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
        try {
            FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), '匯出'+CommonUtil.dateFormat(new Date()).replace(':','_')+'.xlsx')
        } catch (e) {
            if (typeof console !== 'undefined') console.log(e, wbout)
        }           
      })
    },
 
  }
};
</script>
